/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DiscoverShopifyMetafieldsRequest
 */
export interface DiscoverShopifyMetafieldsRequest {
  /**
   *
   * @type {string}
   * @memberof DiscoverShopifyMetafieldsRequest
   */
  integrationId: string;
}

/**
 * Check if a given object implements the DiscoverShopifyMetafieldsRequest interface.
 */
export function instanceOfDiscoverShopifyMetafieldsRequest(
  value: object,
): value is DiscoverShopifyMetafieldsRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  return true;
}

export function DiscoverShopifyMetafieldsRequestFromJSON(
  json: any,
): DiscoverShopifyMetafieldsRequest {
  return DiscoverShopifyMetafieldsRequestFromJSONTyped(json, false);
}

export function DiscoverShopifyMetafieldsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DiscoverShopifyMetafieldsRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
  };
}

export function DiscoverShopifyMetafieldsRequestToJSON(
  json: any,
): DiscoverShopifyMetafieldsRequest {
  return DiscoverShopifyMetafieldsRequestToJSONTyped(json, false);
}

export function DiscoverShopifyMetafieldsRequestToJSONTyped(
  value?: DiscoverShopifyMetafieldsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
  };
}
